import { caregiversApi } from "../../api/directory";
import { DirectoryFormPage } from "./DirectoryFormPage";
import { CAREGIVER_STATUSES } from "./statuses";

const BLANK_CAREGIVER = {
  first_name: "",
  last_name: "",
  status: "applicant",
  phone: "",
  email: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  postal_code: "",
};

export function CaregiverFormPage() {
  return (
    <DirectoryFormPage
      resource={caregiversApi}
      statuses={CAREGIVER_STATUSES}
      blankValues={BLANK_CAREGIVER}
      basePath="/caregivers"
      listLabel="Caregivers"
      newTitle="New caregiver"
    />
  );
}
